import { DEFAULT_CURRENT_TICKER } from '../../../stock_config/stock-ui-config';
import { CommonError } from '../../types';
import { TickerActions } from './actions';
import {
    FETCH_GROUP_TICKERS_FAILURE,
    FETCH_GROUP_TICKERS_REQUEST,
    FETCH_GROUP_TICKERS_SUCCESS,
    FETCH_TICKERS_FAILURE,
    FETCH_TICKERS_REQUEST,
    FETCH_TICKERS_SUCCESS,
    SET_CURRENT_TICKERS,
} from './constants';
import { CurrentTicker, TickerInfo } from './types';

export interface TickerGroupState {
    group: string;
    tickers: string[];
    loading: boolean;
    error: CommonError | null;
}

export interface TickerState {
    tickers: TickerInfo;
    currentTicker: CurrentTicker;
    loading: boolean;
    error: CommonError | null;
}

const initialStateGroup: TickerGroupState = {
    group: '',
    tickers: [],
    loading: false,
    error: null,
};

const initialStateAll: TickerState = {
    tickers: {},
    currentTicker: DEFAULT_CURRENT_TICKER,
    loading: false,
    error: null,
};

export const tickerGroupReducer = (state = initialStateGroup, action: TickerActions): TickerGroupState => {
    switch (action.type) {
        case FETCH_GROUP_TICKERS_REQUEST:
            return { ...state, group: action.payload, loading: true, error: null };
        case FETCH_GROUP_TICKERS_SUCCESS:
            return { ...state, loading: false, tickers: action.payload };
        case FETCH_GROUP_TICKERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export const tickerAllReducer = (state = initialStateAll, action: TickerActions): TickerState => {
    switch (action.type) {
        case FETCH_TICKERS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_TICKERS_SUCCESS:{
          return { ...state, loading: false, tickers: action.payload };
        }
        case FETCH_TICKERS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_CURRENT_TICKERS:  return { ...state,  currentTicker: action.payload };
        default:
            return state;
    }
};
